<template>
  <div>
    <template v-if="panier.length > 0">
      <div v-for="produit in panier" :key="produit.id">
        <div class="d-flex justify-space-between">
          <div class="d-flex">
            <v-img :src="produit.photo" max-width="30" max-height="30" contain class="mr-3"></v-img>
            <div>
              <h3 class="subtitle-2">
                {{ produit.quantite }}x
                <router-link :to="{ name: 'Produit', params: { id: produit.id }, query: { ...$route.query } }">
                  <span>{{ produit.titre }}</span>
                </router-link>
              </h3>
              <span class="caption"> {{ produit.prix | money }} </span>
            </div>
          </div>

          <div>
            <h3>{{ (produit.quantite * produit.prix) | money }}</h3>
          </div>
        </div>
        <div class="text-right">
          <v-btn small text color="info" @click="ADD_ITEM(produit)"
            ><v-icon small class="mr-2">mdi-plus</v-icon>{{ $t("boutique.panier.ajouter") }}</v-btn
          >
          <v-btn small text color="error" @click="REMOVE_ITEM(produit)"
            ><v-icon small class="mr-2">mdi-minus</v-icon>{{ $t("boutique.panier.retirer") }}</v-btn
          >
        </div>
        <v-divider class="my-3" />
      </div>
      <template v-if="loadingTotal">
        <div class="text-center my-3">
          <v-progress-circular indeterminate></v-progress-circular>
        </div>
      </template>

      <template v-else>
        <div class="mb-6">
          <div class="d-flex justify-space-between">
            <span>{{ $t("boutique.panier.fraisPoste") }}</span>
            <span>{{ total.fraisPoste | money }}</span>
          </div>
          <div class="d-flex justify-space-between">
            <span>{{ $t("boutique.panier.fraisSup") }}</span>
            <span>{{ total.fraisSup | money }}</span>
          </div>
          <div class="d-flex justify-space-between">
            <span>{{ $t("boutique.panier.tps") }}</span>
            <span>{{ total.tps | money }}</span>
          </div>
          <div class="d-flex justify-space-between">
            <span>{{ $t("boutique.panier.tvq") }}</span>
            <span>{{ total.tvq | money }}</span>
          </div>
          <div class="d-flex justify-space-between title">
            <span>{{ $t("boutique.panier.total") }}</span>
            <span>{{ total.total | money }}</span>
          </div>
        </div>
      </template>
    </template>
    <template v-else>
      <p class="text-center">{{ $t("boutique.panier.panierVide") }}</p>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
export default {
  computed: {
    ...mapGetters(["panier", "total", "loadingTotal"])
  },
  methods: {
    ...mapActions(["REMOVE_ITEM", "ADD_ITEM"])
  }
}
</script>